import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import CryptoWalletHero from "./CryptoWalletHero";
import RobustSecurity from "./RobustSecurity";
import WhatisCWallet from "./WhatisCWallet";
import MobileWallets from "./MobileWallets";
import Functionalities from "./Functionalities";
import ExperiencedTeam from "../../Exchange/Market Making Services/ExperiencedTeam";
import WhyChoose from "../NFT Wallet/WhyChoose";

function CryptocurrencyWallet() {
  return (
    <div>
      <Header />
      <CryptoWalletHero />
      <WhatisCWallet />
      <RobustSecurity />
      <MobileWallets />
      <Functionalities />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default CryptocurrencyWallet;
